<template>
  <div id="Lishikaijiang">历史开奖</div>
</template>
<script>
export default {
  name: "Lishikaijiang"
};
</script>
<style lang="less" scoped>
#Lishikaijiang {
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Lishikaijiang/index.vue